import { z } from "zod";
export const ClientWorkspaceDesignDirectionV1Schema = z.object({ schemaVersion: z.literal("client-workspace-design-direction.v1.0"), requirementId: z.literal("CW-006"), ok: z.boolean() }).strict();
//# sourceMappingURL=client-workspace-design-direction.js.map